// extracted by mini-css-extract-plugin
export const featuredTitle = "FeaturedList-module--featuredTitle--2J4mw bootstrap--h6--29Wuv bootstrap--font-weight-bold--1VvNN";